export const DEFAULT_VALIDATION_MESSAGES = {
  CURRENCY: 'A currency is required',
  CUSTOMER_ID: 'A customer is required',
  TITLE: 'A quote title is required',
  DEAL_TYPE: 'A deal type is required',
  EXPIRY: 'An expiry date is required',
  QUOTE_NUMBER: 'A quote number is required',
  START_DATE: 'A start date is required'
}
